import React, {lazy, Suspense} from 'react';
import GuestGuard from "gaurds/GuestGuard";
import {Route} from "react-router-dom";
import Spinner from "../components/Spinner";

const Login = lazy(() => import("../pages/login/Login"));

const guestRoutes = (
    <>
        <Route path='/' element={<GuestGuard>
            <Suspense fallback={<Spinner/>}>
                <Login/>
            </Suspense>
        </GuestGuard>}/>
    </>
);

export default guestRoutes;
